import React,{useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Itemvideo from './../atoms/ItemVideo'
import Filter from './../atoms/Filter'
import Modalpopup from './../atoms/Modal/popUp'
import Youtube from 'react-youtube'
import ProductSelection from '../atoms/ProductSelection'

const styles = (theme => ({
  root: {
    minWidth: 645,
    minHeight: 748,
    background: '#FFFFFF',
    boxShadow: '32px 32px 64px 0px rgba(23, 65, 151, 0.10)',
    borderRadius: 10,
    padding: '32px',
    '@media (max-width:1279px)': {
      minWidth: 'auto',
      width: '100%',
    }
  },
  header: {
    borderBottom: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 0 24px 0',
    width: '100%',
    alignItems: 'center',
    gap: 40,
    '&.row': { marginLeft: 0, marginRight: 0 },
    '& > [class*="col-"]': { paddingLeft: 0, paddingRight: 0 },
    '@media (max-width: 960px)': {
      display: 'grid',
      gridTemplateColumns: '1fr',
      rowGap: 12,
      columnGap: 0,
      alignItems: 'start',
      justifyItems: 'start',
    },
  },
  body: {
    width: '100%',
    height: 596,
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 0,
    scrollbarWidth: 'thin',
    scrollbarColor: '#E4EAEE transparent',
    '&::-webkit-scrollbar': { width: 8, height: 8 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#E4EAEE', borderRadius: 8 },
    '@media (max-width:1279px)': { height: 520 }
  },

  message: {
    textAlign: 'center',
    fontStyle: 'italic',
    display: 'block',
    color: '#305178',
  },
  title: {
    display: 'block',
    margin: 0,
    fontFamily: 'var(--font-sans)',
    fontWeight: 600,
    fontSize: 36,
    lineHeight: '44px',
    letterSpacing: '-0.02em',
    color: '#002857',
    '@media (max-width: 960px)': { fontSize: 28, lineHeight: '36px', marginBottom: 4 },
  },
})
)

function VideoList(data){
    const {classes,videos,message,title,onSelectedFilter,children,orderByAsc,onProductFilter,searchText,productsFirstTime} = data

    function onSelectedFilterAplied (filterBy,descendingorderBy){

        if(onSelectedFilter !== null){
            onSelectedFilter(filterBy,descendingorderBy)
        }
    }

    const [videoID,setVideoID] = useState('')
    const opts = {
        height: '440px',
        width: '100%',
        playerVars: {
          autoplay: 1
        }
      };
    function onClickItemVideo(link){

        if(link.length > 0){
            setModal(!isOpen)
        }
        setVideoID(getvideoID(link))
    }
    function onModalClose(){

        setModal(false)
    }
    function getvideoID(link){
      if(!link) return ''
      try{
        const u = new URL(link)
        if (u.hostname.includes('youtu.be')) return u.pathname.slice(1)
        const v = u.searchParams.get('v')
        if (v) return v
        const m = u.pathname.match(/\/embed\/([0-9A-Za-z_-]{11})/)
        if (m) return m[1]
      }catch(e){}
      const m2 = String(link).match(/(?:v=|\/embed\/|youtu\.be\/)([0-9A-Za-z_-]{11})/)
      return m2 ? m2[1] : ''
    }

    const [isOpen,setModal]= useState(false)

    const AppYTbe = ({opts,videoID}) => {

         return(

        <div className='VideoContainer'>
           <Youtube  videoId={videoID} />
       </div>
    )}

    const onProductFilterApplied = (product) => {
        try {
            if(onProductFilter) {
                onProductFilter(product)
            }
        }
        catch(error) {
            console.log(error)
        }
    }

    return(
        <div>
            <div className={`${classes.root} listVideos`}>
                <div id='video_header' className={`${classes.header} row`}>
                    <div className = {`${classes.title} col-md-2 col-sm-12`}>{title}</div>
                    <ProductSelection onSelected={ onProductFilterApplied }
                                    productsFirstTime={ productsFirstTime } />
                    <Filter onSelected={ onSelectedFilterAplied }  orderByAsc = {orderByAsc} />
                </div>
                <div className={`${classes.body} bodyList`}>
                {children}
                {
                videos ? videos.length > 0 ?
                    videos.map((val,index) => {
                        return (
                            <Itemvideo key={index} data = {val} fx="vignette"
                                    product={val.product}
                                    configData={{anchorLinked:false,onclickedPbIcon : onClickItemVideo}}>
                            </Itemvideo>
                        )
                })
                :
                (<span className={classes.message}>{message}</span>)
                :
                (<span className={classes.message}>{message}</span>)
                }
            </div>
        </div>
        <Modalpopup isOpen={isOpen} title='Video' onClose={onModalClose}>
                    <AppYTbe opts={opts} videoID={videoID}  />
            </Modalpopup>
        </div>

    )
}
VideoList.propTypes = {
    videos: PropTypes.array,
    emptyvideosMessage:PropTypes.string
}

VideoList.defaultProps = {
    message:'',
    title:'PlayList',
    onSelectedFilter:null,

}
const VideoListStyles = withStyles(styles)(VideoList)
export default VideoListStyles
